import { useState, useEffect } from "react";
import Link from "next/link";
import Head from "next/head"; // Import Head for SEO
import { getCounsellingPosts } from "@/lib/api";
import { getPGCounsellingPosts } from "@/lib/api";
//import WebinarModal from "@/components/WebinarModal.js";
import OneToOneSession from "../components/OneToOneSessionModal";
import CounsellingModal from "./CounsellingModal.js";
import LoginPromptModal from "../components/homes/heros/LoginPromptModal"; // Import LoginPromptModal
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NeetContent from "../../cms-ghost-app/pages/counselling/NeetContent.js";
import {
  faMapMarkerAlt,
  faStar,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"; // Remove faCalendarAlt import
import { getCookie } from "utils/index";
import Image from "next/image.js";
import University from "../public/images/University.webp";
import { FaInfoCircle } from "react-icons/fa";
import {
  faCartPlus,
  faPaperPlane,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons"; // Remove faCalendarAlt import
import { useCart } from "../context/CartContext.js"; // Import useCart
import { FaPaperPlane } from "react-icons/fa6";
import { useRouter } from "next/router"; // ✅ Import useRouter

// Dropdown Menu Component
const Dropdown = ({ label, options, onSelect, showMCC = true }) => {
  const uniqueOptions = [
    ...(showMCC ? ["MCC"] : []),
    ...new Set(
      options
        .filter((option) => showMCC || option !== "MCC")
        .sort((a, b) => a.localeCompare(b))
    ),
  ];
  return (
    <div className="relative inline-block text-left md:w-48 w-30">
      <select
        className="w-full border border-[#ff9245] sm:px-4 sm:py-2 px-2 py-1 rounded-full appearance-none pr-8 sm:text-sm text-xs scrollbar-custom"
        onChange={(e) => onSelect(e.target.value)}
      >
        <option value="">{label}</option>
        {uniqueOptions.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-gray-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a 1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};

// CounsellingCard Component to render individual counselling post
const CounsellingCard = ({ counselling }) => {
  const router = useRouter(); // ✅ Initialize router
  const { addToCart } = useCart();
  const [counsellingData, setCounsellingData] = useState(null);
  const authToken = getCookie("authToken"); // Retrieve auth token
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoginPromptOpen, setIsLoginPromptOpen] = useState(false);


  useEffect(() => {
    if (counselling.custom_excerpt) {
      try {
        const parsedData = JSON.parse(counselling.custom_excerpt);
        setCounsellingData(parsedData);
      } catch (error) {
        console.error("Failed to parse custom_excerpt:", error);
      }
    }
  }, [counselling.custom_excerpt]);

  const handleStartCounselling = () => {
    const title = encodeURIComponent(counselling.title);
    const location = encodeURIComponent(counsellingData.location);
    localStorage.setItem("counsellingTitle", title);
    localStorage.setItem("counsellingLocation", location);

    if (authToken) {
      window.location.href = `https://portal.neetsupport.com/dashboard-Counselling?title=${title}&location=${location}`;
    } else {
      setIsLoginPromptOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    const title = localStorage.getItem("counsellingTitle");
    const location = localStorage.getItem("counsellingLocation");
    window.location.href = `https://portal.neetsupport.com/dashboard-Counselling?title=${title}&location=${location}`;
  };

  const handleAddToCart = (counselling) => {
    const itemWithImage = { ...counselling, image: counselling.feature_image }; // Include image
    addToCart(itemWithImage); // Add to cart logic
    if (authToken) {
      const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      cartItems.push(itemWithImage);
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
    }
  };

  return (
    <>
      <div
        className="block border rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow duration-300 w-full max-w-[350px] mx-auto flex-col h-full cursor-pointer"
        onClick={() => {
          if (counselling.slug) {
            router.push(`/counselling/${counselling.slug}`);
          } else {
            alert("Details not available for this counselling post.");
          }
        }} // ✅ Guard against missing slug
      >
        <img
          src={counselling.feature_image} // Use the feature image from the counselling post data
          alt={counselling.title} // Use title as alt text
          className="rounded-lg w-full h-40 object-fill" // Explicit image size
        />

        {/* Counselling Details */}
        <div className="mt-4 flex-grow">
          <h3 className="text-sm md:text-md font-semibold line-clamp-2 overflow-hidden text-ellipsis whitespace-normal">
            {counselling.title}
          </h3>
          {counsellingData ? (
            <>
              <div className="text-xs sm:text-sm text-gray-500 flex justify-between items-center">
                {/* <p>Counselling Type: {counsellingData.type}</p>
                <span>Seats: {counsellingData.seatsAvailable}</span> */}
              </div>
              <div className="text-xs sm:text-sm text-gray-500 flex justify-between items-center mt-1">
                <p className="flex items-center">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="mr-2 text-[#005F59] w-4 h-4" // Explicit icon size
                  />
                  {counsellingData.location}
                </p>
              </div>
              <p className="text-xs sm:text-sm text-gray-500 flex items-center mt-1">
                <FontAwesomeIcon
                  icon={faStar}
                  className="mr-2 text-yellow-500 w-4 h-4"
                />{" "}
                {/* Explicit icon size */}
                {counsellingData.reviewCount} Reviews
              </p>
            </>
          ) : (
            <p>Loading data...</p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="mt-4 flex justify-between items-center">
          <div className="">
            <button
              className="relative text-[#ff9245] px-3 py-1 !ring-1 ring-[#ff9245] rounded-full transition-colors hover:text-[#fff] hover:bg-[#ff9245] text-xs md:text-sm duration-300"
              onClick={(e) => {
                e.stopPropagation();
                if (counselling.slug) {
                  router.push(`/counselling/${counselling.slug}`);
                } else {
                  alert("Details not available for this counselling post.");
                }
              }} // ✅ Guard against missing slug
            >
              View Details
            </button>
          </div>
          <div className="animate-blink rounded-full">
            <button
              className="px-3 py-1 text-xs md:text-sm rounded-full bg-[#ff9245] text-white border border-[#ff9245] hover:bg-white hover:!text-[#ff9245] hover:border-[#ff9245] hover:ring-1 hover:ring-[#ff9245] transition-colors duration-300 flex items-center"
              onClick={(e) => {
                e.stopPropagation();
                handleStartCounselling();
              }}
            >
              <FaPaperPlane className="mr-2" />
              <span>Start Counselling</span>
            </button>
          </div>
        </div>
      </div>
      <CounsellingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        counselling={counselling}
        location={counsellingData?.location || "Not Available"} // Pass location
      />
      {isLoginPromptOpen && (
        <LoginPromptModal
          onClose={() => setIsLoginPromptOpen(false)}
          onLoginSuccess={handleLoginSuccess}
          title={localStorage.getItem("counsellingTitle")}
          location={localStorage.getItem("counsellingLocation")}
          tag="Counselling"
        />
      )}
    </>
  );
};

// CounsellingList Component to render the list of counselling posts
const CounsellingList = ({ allCounsellingPosts, allPGCounsellingPosts }) => {
  const postsPerPage = 9;
  // Webinar modal state and timer
  //const [showWebinarModal, setShowWebinarModal] = useState(false);
  const [showOneToOneModal, setShowOneToOneModal] = useState(false);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowWebinarModal(true);
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, []);
    useEffect(() => {
    const timer = setTimeout(() => {
      setShowOneToOneModal(true);
    }, 8000);
    return () => clearTimeout(timer);
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLocationOpen, setLocationOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [toggleState, setToggleState] = useState("UG Counselling");

  const startIdx = (currentPage - 1) * postsPerPage;

  // Select posts based on toggle
  const postsToShow = toggleState === "PG Counselling" ? allPGCounsellingPosts : allCounsellingPosts;

  useEffect(() => {
    const states = new Set();
    postsToShow.forEach((post) => {
      let counsellingData = null;
      if (post.custom_excerpt) {
        try {
          counsellingData = JSON.parse(post.custom_excerpt);
          if (counsellingData?.location) {
            states.add(counsellingData.location);
          }
        } catch (error) {
          console.error("Failed to parse custom_excerpt:", error);
        }
      }
    });
    setStateOptions([...Array.from(states)]);
  }, [postsToShow]);
  useEffect(() => {
    setSelectedLocation("All");
    setCurrentPage(1);
  }, [toggleState]);

  useEffect(() => {
    if (searchQuery) {
      const results = postsToShow.filter((post) =>
        post.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery, postsToShow]);

  // Add tag extraction for each post
  const getTags = (post) => Array.isArray(post.tags) ? post.tags.map(t => t.slug) : [];

  const filteredPosts = postsToShow.filter((post) => {
    const counsellingData = JSON.parse(post.custom_excerpt || "{}");
    const tags = Array.isArray(post.tags) ? post.tags.map(t => t.slug) : [];

    const matchesLocation =
      !selectedLocation ||
      selectedLocation === "All" ||
      counsellingData.location === selectedLocation;

    const matchesSearchQuery = post.title
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    return matchesLocation && matchesSearchQuery;
  });

  const stateOrder = [
    "Uttar Pradesh",
    "Maharashtra",
    "Tamil Nadu",
    "Karnataka",
    "Telangana",
    "Rajasthan",
    "Gujarat",
    "Andhra Pradesh",
    "West Bengal",
    "Kerala",
    "Madhya Pradesh",
    "Bihar",
    "Odisha",
    "Chhattisgarh",
    "Haryana",
    "Assam",
    "Punjab",
    "Jammu Kashmir",
    "Delhi",
    "Uttarakhand",
    "Puducherry",
    "Jharkhand",
    "Himachal Pradesh",
    "Manipur",
    "Tripura",
    "Meghalaya",
  ];

  // Ensure MCC post is first, then states in the specified order, then others alphabetically
  const sortedPosts = filteredPosts.sort((a, b) => {
    const aData = JSON.parse(a.custom_excerpt || "{}");
    const bData = JSON.parse(b.custom_excerpt || "{}");

    // MCC always first
    if (aData.location === "MCC") return -1;
    if (bData.location === "MCC") return 1;

    // Both in stateOrder
    const aIndex = stateOrder.findIndex(
      (state) => state.toLowerCase() === (aData.location || "").toLowerCase()
    );
    const bIndex = stateOrder.findIndex(
      (state) => state.toLowerCase() === (bData.location || "").toLowerCase()
    );

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }
    // Only a in stateOrder
    if (aIndex !== -1) return -1;
    // Only b in stateOrder
    if (bIndex !== -1) return 1;

    // Neither in stateOrder: sort alphabetically
    return (aData.location || "").localeCompare(bData.location || "");
  });

  const currentPosts = sortedPosts.slice(startIdx, startIdx + postsPerPage);
  const totalPages = Math.ceil(sortedPosts.length / postsPerPage);
  // Function to toggle location dropdown
  const toggleDropdown = () => {
    setLocationOpen(!isLocationOpen);
  };
  const handleSearch = () => {
    if (searchQuery) {
      window.open(
        `https://www.google.com/search?tbm=isch&q=${encodeURIComponent(
          searchQuery
        )}`,
        "_blank"
      );
    }
  };
  return (
    <>
      {/* <WebinarModal
        isOpen={showWebinarModal}
        onClose={() => setShowWebinarModal(false)}
      /> */}
      <OneToOneSession
        isOpen={showOneToOneModal}
        onClose={() => setShowOneToOneModal(false)}
      />
      <Head>
        <title>NEET Counselling Bodies - State & AIQ Quota: NEET Support</title>
        <link rel="shortcut icon" href="/favicon.ico" />
        <meta
          name="description"
          content="Learn about NEET counselling, state and AIQ quota, different counselling bodies, and MCC NEET updates. Get all the information you need to understand NEET counselling."
        />
        <meta
          name="keywords"
          content="counselling bodies, neet counselling, state quota counselling, AIQ counselling, mcc neet counselling, neet counselling 2026"
        />
        <meta
          property="og:title"
          content="NEET Counselling 2026 - State & AIQ Quota, Counselling Bodies"
        />
        <meta
          property="og:description"
          content="Get all the information you need about NEET counselling, including state and AIQ quota, counselling bodies, and MCC NEET updates. Make your NEET counselling process easier."
        />
        <meta
          property="og:image"
          content={allCounsellingPosts[0]?.feature_image || "/default.jpg"}
        />
        <meta
          property="og:url"
          content={typeof window !== "undefined" ? window.location.href : ""}
        />
        <link rel="canonical" href="https://neetsupport.com/counselling" />
      </Head>
      <section className="flex-col flex items-center md:justify-between mt-16 mb-16 md:mb-12">
        {/* New Section for Search and Predictors */}
        <div className="relative w-full h-[380px] flex items-center justify-center">
          {/* Background Image */}
          <div className="absolute inset-0">
            <Image
              src={University}
              alt="University"
              layout="fill"
              objectFit="cover"
              className="absolute inset-0"
            />
            {/* Black Overlay with Lower Opacity */}
            <div className="absolute inset-0 bg-gray-600 bg-opacity-50"></div>
          </div>

          {/* Overlay for Readability */}
          <div className="absolute inset-0 "></div>

          {/* Content */}
          <div className="relative z-10 text-center text-white px-4">
            {/* Heading */}
            <h1 className="text-xl md:text-2xl lg:text-3xl xl:text-3xl font-bold">
              Explore AIQ and State NEET Counselling Bodies-NEET Counselling
              Made Easy
            </h1>
            <p className="text-sm md:text-sm lg:text-lg xl:text-lg mt-2">
              Explore AIQ & State NEET counselling with expert guidance. Get
              precise choice filling, real-time cutoffs, and full admission
              support to secure your medical seat.
            </p>
            {/* Search Bar */}
            <div className="mt-6 flex justify-center">
              <div className="relative w-full max-w-xs md:max-w-lg">
                <input
                  type="text"
                  placeholder="Search Counselling...."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-6 py-4 rounded-full text-black shadow-lg focus:outline-none"
                />
                <button
                  className="absolute !rounded-3xl right-2 top-1/2 transform -translate-y-1/2 text-white"
                  onClick={handleSearch}
                ></button>
                {searchResults.length > 0 && (
                  <div className="mt-1 bg-white text-black z-10 rounded-lg shadow-lg p-4 max-w-xs md:max-w-lg mx-auto absolute top-full left-0 right-0 max-h-60 overflow-y-auto">
                    <h3 className="text-lg font-semibold mb-2 text-[#ff9245]">
                      Search Results:
                    </h3>
                    <ul>
                      {searchResults.map((result) => (
                        <li key={result.id} className="mb-2">
                          <Link href={`/counselling/${result.slug}`}>
                            <span className="text-gray-700 text-sm hover:underline hover:text-blue-500 ">
                              {result.title}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            {/* Buttons */}
            <div className="mt-6 flex justify-center space-x-1 sm:space-x-4">
              <button
                className="bg-[#ff9245] hover:ring-[#fff] hover:bg-[#fff] hover:!text-[#ff9245] text-white px-4 py-2 rounded-full text-[10px] sm:text-xs font-semibold transition"
                onClick={() =>
                  (window.location.href = "/neet-college-predictor")
                }
              >
                College Predictor
              </button>
              <button
                className="bg-[#ff9245] hover:ring-[#fff] hover:bg-[#fff] hover:!text-[#ff9245] text-white px-4 py-2 rounded-full text-[10px] sm:text-xs font-semibold transition"
                onClick={() => (window.location.href = "/neet-rank-predictor")}
              >
                Rank Predictor
              </button>
              <button
                className="bg-[#ff9245] hover:ring-[#fff] hover:bg-[#fff] hover:!text-[#ff9245] text-white px-4 py-2 rounded-full text-[10px] sm:text-xs font-semibold transition"
                onClick={() =>
                (window.location.href =
                  "https://portal.neetsupport.com/dashboard-Counselling")
                }
              >
                Personalized Counselling
              </button>
            </div>{" "}
          </div>
        </div>
        <div className="p-8">
          {/* <h1 className="text-center lg:text-2xl md:text-lg text-[17px] font-bold mb-6 underline text-[#ff9245]">
            Explore AIQ and State NEET Counselling Bodies
          </h1> */}

          <div className="flex justify-between items-center mb-6 p-4 flex-wrap gap-4">
            {/* Left: Record Count */}
            <div className="flex items-center">
              <span className="font-semibold text-xs sm:text-[15px] text-black mr-2">
                Showing{" "}
                <span className="text-[#005F59] font-semibold">
                  {filteredPosts.length} records
                </span>
              </span>
              <FaInfoCircle className="text-[#005F59] text-lg" />
            </div>

            {/* Right: Dropdown */}
            <Dropdown
              label="Select Counselling"
              options={stateOptions}
              onSelect={(state) => {
                setSelectedLocation(state || "All");
                setCurrentPage(1);
              }}
              showMCC={toggleState !== "PG Counselling"}
            />
          </div>
          <div className="flex justify-center mb-8">
            <div className="inline-flex items-center bg-[#ff9245] rounded-full p-1">
              <button
                className={`px-4 py-1 rounded-full transition-all duration-300 font-bold text-sm ${toggleState === "UG Counselling"
                    ? "bg-white text-[#ff9245] shadow"
                    : "text-white"
                  }`}
                onClick={() => setToggleState("UG Counselling")}
              >
                UG Counselling
              </button>
              <button
                className={`px-4 py-1 rounded-full transition-all duration-300 font-bold text-sm ${toggleState === "PG Counselling"
                    ? "bg-white text-[#ff9245] shadow"
                    : "text-white"
                  }`}
                onClick={() => setToggleState("PG Counselling")}
              >
                PG Counselling
              </button>
            </div>
          </div>
          {/* Counselling Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3  gap-8">
            {currentPosts && currentPosts.length > 0 ? (
              currentPosts.map((counselling) => (
                <CounsellingCard
                  key={counselling.id}
                  counselling={counselling}
                />
              ))
            ) : (
              <div className="text-center col-span-full">
                No counselling posts available for this location.
              </div>
            )}
          </div>

          {/* Pagination */}
          {/* <div className="flex justify-center mt-8">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                className={`mx-1 px-3 py-1 rounded-full ${
                  currentPage === index + 1
                    ? "bg-[#ff9245] text-white"
                    : "bg-gray-200 text-gray-700"
                }`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div> */}

          <div className="flex justify-center mt-8 items-center space-x-1">
            <button
              className={`px-3 py-1 rounded-full ${currentPage === 1
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-gray-200 text-gray-700 hover:bg-[#ff9245] hover:text-white"
                }`}
              onClick={() => {
                if (currentPage > 1) {
                  setCurrentPage(currentPage - 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
              disabled={currentPage === 1}
              aria-label="Previous Page"
            >
              &lt;
            </button>
            {(() => {
              const pages = [];
              let start = Math.max(1, currentPage - 2);
              let end = Math.min(totalPages, start + 4);
              if (end - start < 4) {
                start = Math.max(1, end - 4);
              }
              for (let i = start; i <= end; i++) {
                pages.push(
                  <button
                    key={i}
                    className={`mx-1 px-3 py-1 rounded-full ${currentPage === i
                        ? "bg-[#ff9245] text-white"
                        : "bg-gray-200 text-gray-700 hover:bg-[#ff9245] hover:text-white"
                      }`}
                    onClick={() => {
                      setCurrentPage(i);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    {i}
                  </button>
                );
              }
              return pages;
            })()}
            <button
              className={`px-3 py-1 rounded-full ${currentPage === totalPages || totalPages === 0
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-gray-200 text-gray-700 hover:bg-[#ff9245] hover:text-white"
                }`}
              onClick={() => {
                if (currentPage < totalPages) {
                  setCurrentPage(currentPage + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
              disabled={currentPage === totalPages || totalPages === 0}
              aria-label="Next Page"
            >
              &gt;
            </button>
          </div>
        </div>

      </section>
      {toggleState === "UG Counselling" && <NeetContent />}
    </>
  );
};

// Fetch counselling posts using getStaticProps
export async function getStaticProps({ preview }) {
  const allCounsellingPosts = (await getCounsellingPosts(preview)) || [];
  const allPGCounsellingPosts = (await getPGCounsellingPosts(preview)) || [];

  // Clean feature_image URLs
  allCounsellingPosts.forEach((post) => {
    if (post.feature_image) {
      post.feature_image = post.feature_image.replace(
        /ghost\.neetsupport\.com/g,
        "neetsupport.com"
      );
    }
  });
  allPGCounsellingPosts.forEach((post) => {
    if (post.feature_image) {
      post.feature_image = post.feature_image.replace(
        /ghost\.neetsupport\.com/g,
        "neetsupport.com"
      );
    }
  });

  return {
    props: { allCounsellingPosts, allPGCounsellingPosts },
    revalidate: 10, // Revalidate every 10 seconds for ISR
  };
}

export default CounsellingList;
